export type UserDatabase = {
    databaseCompanyId: number;
    databaseCompanyName: string;
    databaseId: number;
    databaseName: string;
};

export type UserType = "analyst" | "admin";

export const canDeleteExtraction = (
    userType: UserType | undefined,
    extraction: { allowUserDeletion: boolean; hasCompleted: boolean },
) =>
    userType === "admin" ||
    extraction.allowUserDeletion ||
    !extraction.hasCompleted;

export const canDeleteFile = (
    userType: UserType | undefined,
    file: { allowUserDeletion: boolean },
) => canDeleteExtraction(userType, { ...file, hasCompleted: true });

export enum BetaTesterFeature {
    MODEL_SELECTION = "model_selection",
    RENT_ROLL_UPLOAD = "rent_roll_upload",
    LLM_EXTRACTION = "llm_extraction",
}
